import React, { FC } from "react";
import styled from "styled-components/macro";
import Module from "shared/lib/interfaces/Module";
import ModuleSection from "shared/lib/interfaces/ModuleSection";
import SlidePage, { SlidePageProgress, SlidePageProps } from "../../SlidePage";
import YellowCircleList from "../../../../common/components/YellowCircleList";

interface Props {
  module: Pick<Module, "icon" | "name">;
  section: Pick<ModuleSection, "name">;
  progress: SlidePageProgress;
  onNext: SlidePageProps["onNext"];
  onBack: SlidePageProps["onBack"];
}

const ProactiveParentingBenefitsOfFamilyRoutinesSlide: FC<Props> = (props) => {
  const { module, section, ...rest } = props;

  return (
    <SlidePage {...rest} title={module.name}>
      <section>
        <h3>Benefits of Family Routines</h3>
        <p>
          Research has shown that children who grow up with consistent routines
          have better emotional control and coping skills as adults.
        </p>
      </section>
      <section>
        <h3>Routines also:</h3>
        <YellowCircleList>
          <li>Provide predictability for your child.</li>
          <li>Assist with consistent rules for your child.</li>
          <li>Help your child cope with transitions.</li>
          <li>
            Support a healthy lifestyle through regular sleep, meals, and
            exercise.
          </li>
        </YellowCircleList>
      </section>
    </SlidePage>
  );
};

export default styled(ProactiveParentingBenefitsOfFamilyRoutinesSlide)``;
